module.exports = __webpack_public_path__ + "img/dance-tiao-icon1.2afc36d6.png";